module.exports = __webpack_public_path__ + "static/media/mlhFellowship.56f855b7.svg";